import { businessKey } from 'scenes/FinancePage/data/queryKeyFactory';

export const FR = 'FR';
export const FRBusinessKey = businessKey.query(FR);

export const details = FRBusinessKey.details();
export const logs = FRBusinessKey.logs();
export const mutations = FRBusinessKey.mutations();

export const moreInfo = mutations.moreInfo();
export const approve = mutations.approve();
export const reject = mutations.reject();
export const undo = mutations.undo();
export const download = mutations.download();
